import type * as React from 'react'

import { cn } from '../../lib/utils'

/**
 * The `Input` box, grown to several lines (DESIGN.md §5 "Inputs and fields"):
 * the same boundary, paper, corners, hover, ring, invalid and disabled
 * states.
 *
 * Vertical resize only. A textarea the user can widen escapes the form grid
 * and pushes the columns beside it out of alignment.
 */
function Textarea({
  className,
  invalid,
  ...props
}: React.ComponentProps<'textarea'> & { invalid?: boolean }) {
  return (
    <textarea
      data-slot="textarea"
      aria-invalid={invalid || undefined}
      className={cn(
        'field-sizing-content min-h-20 w-full resize-y rounded-sm border border-input bg-input-background px-2.5 py-2',
        'text-body text-foreground transition-ui placeholder:text-muted-foreground',
        'enabled:hover:border-foreground',
        'focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-ring',
        'aria-invalid:border-danger aria-invalid:enabled:hover:border-danger',
        'disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:text-muted-foreground',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
